/* eslint-disable @typescript-eslint/no-explicit-any */

import { useState } from 'react';
import {
  MutationCache,
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools"

function Provider({ children }: any) {

  const onError = (error: any) => {
    const { body, status } = error as any;
    if (status === 401 && body.redirect === '/unauthorized') {
      return '401'
    }
    return 0;
  };

  const [client] = useState(
    new QueryClient({
      defaultOptions: {
        queries: {
          retry : false,
          staleTime: 5 * 60 * 1000,
          refetchOnWindowFocus: false,
        },
      },
      mutationCache: new MutationCache({ onError }),
      queryCache: new QueryCache({ onError }),
    }),
  );

  return (
    <QueryClientProvider client={client}>
      {children}
    </QueryClientProvider>
  );
}

export default Provider;
